import React, { useContext } from 'react'
import { useTranslation } from 'react-i18next'
import { CInput } from 'app/components/Common'
import { Text, View } from 'styles/reactnative'
import { TransferAmountWrapper } from '../styles'
import TransferAll from './TransferAll'
import TransferableAmount from './TransferableAmount'
import { ThemeContext } from 'theme/ThemeProvider'

const TransferAmount = ({ balance, amount, setAmount }) => {
	const { t } = useTranslation()
	const { textw, gray } = useContext(ThemeContext).theme.COLORS
	return (
		<TransferAmountWrapper>
			<View
				style={{
					alignItems: 'flex-start',
					justifyContent: 'flex-start',
					alignSelf: 'flex-start',
				}}>
				<Text>{t('amount')}</Text>
			</View>
			<CInput
				placeholder={''}
				value={amount}
				type={'text'}
				onChange={(e: any) => setAmount(e.target.value)}
				vStyle={{ width: '100%' }}
				style={{
					flexDirection: 'row',
					background: gray,
					marginTop: 10,
					width: '100%',
					justifyContent: 'space-between',
					padding: 8,
					borderRadius: 5,
					paddingRight: 100,
					cursor: 'pointer',
					border: 'none',
					color: textw,
				}}
			/>
			<TransferAll balance={balance} setAmount={setAmount} />
			<TransferableAmount balance={balance} />
		</TransferAmountWrapper>
	)
}

export default TransferAmount
